const initialState = {
  notificationToggle: false,
  success: false,
  loading: false,
  error: null,
  prioritizeSuccess: false,
  prioritizeType: null,
  currentProperty: {
    data: null,
    loading: false,
    error: null,
  },
  properties: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  registeredProperties: {
    data: null,
    loading: false,
    error: null,
  },
  notifications: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  Mlproperties: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  mlEngineProperties: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  changeRequest: {
    data: null,
    loading: false,
    error: null,
  },
  property: null,
  circles: {
    data: null,
    loading: false,
    error: null,
  },
  notificationCount: undefined,
  searchedProperties: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  registeredPropertiesPercentagesByZone: {
    data: [],
    loading: false,
    error: null,
  },

  //move this to a saperate reducer
  tiDetails: {
    data: null,
    loading: false,
    error: null,
  },

  tiPropertyStats: {
    data: null,
    loading: false,
    error: null,
  },
  lookupTableData: {
    data: null,
    loading: false,
    error: null,
  },
  propertyDetail: {
    data: null,
  },
  updatePropertyDetailResponse: {
    data: null,
    loading: false,
    error: null,
  },
  uploadLookupData: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  AdminRegisteredProperties: {
    data: null,
    loading: false,
    error: null,
  },
  fetchLookupReportResponse: {
    data: null,
    loading: false,
    error: null,
  },
  AdminUnRegisteredProperties: {
    data: null,
    loading: false,
    error: null,
  },
  filterMetaData: {
    data: null,
    loading: false,
    error: null,
  },
  latestFile: {
    data: null,
    loading: false,
    error: null,
  },
  dcRateHistory: {
    data: null,
    loading: false,
    error: null,
  },
};

const propertyReducer = (
  state = initialState,
  { obj, type, error, payload, data, pagination }
) => {
  switch (type) {
    case "GET_FILTER_META_DATA":
      return {
        ...state,
        filterMetaData: {
          ...state.filterMetaData,
          loading: true,
        },
      };
    case "GET_FILTER_META_DATA_SUCCESS":
      return {
        ...state,
        filterMetaData: {
          ...state.filterMetaData,
          loading: false,
          data,
        },
      };
    case "GET_FILTER_META_DATA_FAIL":
      return {
        ...state,
        filterMetaData: {
          ...state.filterMetaData,
          loading: false,
          error,
        },
      };

    case "RESET_FETCH_LOOKUP_REPORT":
      return {
        ...state,
        fetchLookupReportResponse: {
          data: null,
          loading: false,
          error: null,
        },
      };

    case "FETCH_LOOKUP_REPORT":
      return {
        ...state,
        fetchLookupReportResponse: {
          ...state.fetchLookupReportResponse,
          loading: true,
        },
      };

    case "FETCH_LOOKUP_REPORT_SUCCESS":
      return {
        ...state,
        fetchLookupReportResponse: {
          ...state.fetchLookupReportResponse,
          loading: false,
          data,
        },
      };

    case "FETCH_LOOKUP_REPORT_FAIL":
      return {
        ...state,
        fetchLookupReportResponse: {
          ...state.fetchLookupReportResponse,
          loading: false,
          error,
        },
      };

    case "GET_UPLOAD_LOOKUP_DATA":
      return {
        ...state,
        uploadLookupData: {
          ...state.uploadLookupData,
          loading: true,
        },
      };

    case "GET_UPLOAD_LOOKUP_DATA_SUCCESS":
      return {
        ...state,
        uploadLookupData: {
          ...state.uploadLookupData,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_UPLOAD_LOOKUP_DATA_FAIL":
      return {
        ...state,
        uploadLookupData: {
          ...state.uploadLookupData,
          loading: false,
          error,
        },
      };
    case "FETCH_REGISTERED_PROPERTY":
      return {
        ...state,
        AdminRegisteredProperties: {
          ...state.AdminRegisteredProperties,
          loading: true,
        },
      };

    case "FETCH_REGISTERED_PROPERTY_SUCCESS":
      return {
        ...state,
        AdminRegisteredProperties: {
          ...state.AdminRegisteredProperties,
          data,
          loading: false,
        },
      };

    case "FETCH_REGISTERED_PROPERTY_FAIL":
      return {
        ...state,
        AdminRegisteredProperties: {
          ...state.AdminRegisteredProperties,
          error,
          loading: false,
        },
      };

    case "FETCH_UNREGISTERED_PROPERTY":
      return {
        ...state,
        AdminUnRegisteredProperties: {
          ...state.AdminUnRegisteredProperties,
          loading: true,
        },
      };

    case "FETCH_UNREGISTERED_PROPERTY_SUCCESS":
      return {
        ...state,
        AdminUnRegisteredProperties: {
          ...state.AdminUnRegisteredProperties,
          data,
          loading: false,
        },
      };

    case "FETCH_UNREGISTERED_PROPERTY_FAIL":
      return {
        ...state,
        AdminUnRegisteredProperties: {
          ...state.AdminUnRegisteredProperties,
          error,
          loading: false,
        },
      };

    case "RESET_PROPERTY_DETAIL_RESPONSE":
      return {
        ...state,
        updatePropertyDetailResponse: {
          ...state.updatePropertyDetailResponse,
          data: null,
          loading: false,
          error: null,
        },
      };
    case "TOGGLE_NOTIFICATIONS":
      return {
        ...state,
        notificationToggle: !state.notificationToggle,
      };

    case "SET_PROPERTY_DETAIL":
      return {
        ...state,
        propertyDetail: {
          data,
        },
      };

    case "RESET_PROPERTY_DETAIL":
      return {
        ...state,
        propertyDetail: {
          data: null,
        },
      };

    case "UPDATE_PROPERTY_DETAIL":
      return {
        ...state,
        updatePropertyDetailResponse: {
          ...state.updatePropertyDetailResponse,
          loading: true,
        },
      };

    case "UPDATE_PROPERTY_DETAIL_SUCCESS":
      return {
        ...state,
        updatePropertyDetailResponse: {
          ...state.updatePropertyDetailResponse,
          data,
          loading: false,
        },
      };

    case "UPDATE_PROPERTY_DETAIL_FAIL":
      return {
        ...state,
        updatePropertyDetailResponse: {
          ...state.updatePropertyDetailResponse,
          error,
          loading: false,
        },
      };

    case "RESET_PROPERTIES":
      return initialState;

    case "GET_LOOKUP_TABLE_DATA":
      return {
        ...state,
        lookupTableData: {
          ...state.lookupTableData,
          loading: true,
        },
      };
    case "GET_LOOKUP_TABLE_DATA_SUCCESS":
      return {
        ...state,
        lookupTableData: {
          ...state.lookupTableData,
          loading: false,
          data: data,
        },
      };
    case "GET_LOOKUP_TABLE_DATA_FAIL":
      return {
        ...state,
        lookupTableData: {
          ...state.lookupTableData,
          loading: false,
          error,
        },
      };

    case "RESET_CURRENT_PROPERTY":
      return {
        ...state,
        currentProperty: {
          loading: true,
          error: null,
          data: null,
        },
      };
    case "GET_CURRENT_PROPERTY":
      return {
        ...state,
        currentProperty: {
          ...state.currentProperty,
          loading: true,
          error: null,
          data: null,
        },
      };

    case "GET_CURRENT_PROPERTY_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        currentProperty: {
          ...state.currentProperty,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_CURRENT_PROPERTY_FAIL":
      return {
        ...state,
        loggedIn: false,
        currentProperty: {
          ...state.currentProperty,
          loading: false,
          error,
        },
      };

    case "GET_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        properties: {
          ...initialState.properties,
          loading: true,
        },
      };

    case "GET_PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        properties: {
          ...state.properties,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        properties: {
          ...state.properties,
          loading: false,
          error,
        },
      };
    case "GET_REGISTERED_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        registeredProperties: {
          ...state.registeredProperties,
          loading: true,
        },
      };
    case "GET_REGISTERED_PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        registeredProperties: {
          ...state.registeredProperties,
          loading: false,
          data: data,
        },
      };
    case "GET_REGISTERED_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        registeredProperties: {
          ...state.registeredProperties,
          loading: false,
          error,
        },
      };
    case "GET_ML_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        Mlproperties: {
          ...initialState.Mlproperties,
          loading: true,
        },
      };

    case "GET_ML_PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        Mlproperties: {
          ...state.Mlproperties,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_ML_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        Mlproperties: {
          ...state.Mlproperties,
          loading: false,
          error,
        },
      };
    case "GET_ML_ENGINE_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        mlEngineProperties: {
          ...initialState.mlEngineProperties,
          loading: true,
        },
      };

    case "GET_ML_ENGINE_PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        mlEngineProperties: {
          ...state.mlEngineProperties,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_ML_ENGINE_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        mlEngineProperties: {
          ...state.mlEngineProperties,
          loading: false,
          error,
        },
      };

    case "GET_CIRCLES":
      return {
        ...state,
        type,
        error: null,
        circles: {
          ...initialState.circles,
          loading: true,
        },
      };

    case "GET_CIRCLES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        circles: {
          ...state.circles,
          loading: false,
          data: data.data,
        },
      };

    case "GET_CIRCLES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        circles: {
          ...state.circles,
          loading: false,
          error,
        },
      };

    case "GET_NOTIFICATION_COUNT":
      return {
        ...state,
        loading: true,
        type,
        error: null,
        notificationCount: initialState.notificationCount,
      };

    case "GET_NOTIFICATION_COUNT_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        notificationCount: data.count,
      };

    case "GET_NOTIFICATION_COUNT_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
      };

    case "INCREMENT_NOTIFICATION_COUNT":
      return {
        ...state,
        type,
        notificationCount: state.notificationCount + 1,
      };

    case "DECREMENT_NOTIFICATION_COUNT":
      return {
        ...state,
        type,
        notificationCount: state.notificationCount - 1,
      };

    case "SEARCH_PROPERTIES":
      return {
        ...state,
        type,
        error: null,
        searchedProperties: {
          ...initialState.searchedProperties,
          loading: true,
        },
      };

    case "SEARCH__PROPERTIES_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        searchedProperties: {
          ...state.searchedProperties,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
        type,
      };

    case "SEARCH_PROPERTIES_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
      };

    case "RESET_SEARCHED_PROPERTIES":
      return {
        ...state,
        searchedProperties: initialState.searchedProperties,
      };

    case "RESET_ML_PROPERTIES_COUNT":
      return {
        ...state,
        mlPropertiesCount: initialState.mlPropertiesCount,
      };

    case "SET_PROPERTY_APPROVAL":
      return {
        ...state,
        type,
        error: null,
        loading: true,
      };

    case "SET_PROPERTY_APPROVAL_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        properties: {
          ...state.properties,
        },
      };

    case "SET_PROPERTY_APPROVAL_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        properties: {
          ...state.properties,
          loading: false,
          error,
        },
      };

    case "PRIORITIZE_PROPERTY":
      return {
        ...state,
        type,
        error: null,
        loading: true,
      };

    case "PRIORITIZE_PROPERTY_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: data.success,
        prioritizeType: data.type,
      };

    case "PRIORITIZE_PROPERTY_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        prioritizeSuccess: data.success,
      };
    case "GET_NOTIFICATIONS":
      return {
        ...state,
        type,
        error: null,
        notifications: {
          ...initialState.notifications,
          loading: true,
        },
      };

    case "GET_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        notifications: {
          ...state.notifications,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_NOTIFICATIONS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        notifications: {
          ...state.notifications,
          loading: false,
          error,
        },
      };
    case "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE":
      return {
        ...state,
        registeredPropertiesPercentagesByZone: {
          ...state.registeredPropertiesPercentagesByZone,
          loading: true,
        },
      };
    case "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE_SUCCESS":
      return {
        ...state,
        registeredPropertiesPercentagesByZone: {
          ...state.registeredPropertiesPercentagesByZone,
          loading: false,
          data: data,
        },
      };
    case "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE_FAIL":
      return {
        ...state,
        registeredPropertiesPercentagesByZone: {
          ...state.registeredPropertiesPercentagesByZone,
          loading: false,
          error,
        },
      };

    case "GET_TI_DETAILS":
      return {
        ...state,
        tiDetails: {
          ...state.tiDetails,
          loading: true,
        },
      };
    case "GET_TI_DETAILS_SUCCESS":
      return {
        ...state,
        tiDetails: {
          ...state.tiDetails,
          loading: false,
          data: data,
        },
      };
    case "GET_TI_DETAILS_FAIL":
      return {
        ...state,
        tiDetails: {
          ...state.tiDetails,
          loading: false,
          error,
        },
      };

    case "GET_TI_PROPERTY_STATS":
      return {
        ...state,
        tiPropertyStats: {
          ...state.tiPropertyStats,
          loading: true,
        },
      };

    case "GET_TI_PROPERTY_STATS_SUCCESS":
      return {
        ...state,
        tiPropertyStats: {
          ...state.tiPropertyStats,
          loading: false,
          data: data,
        },
      };

    case "GET_TI_PROPERTY_STATS_FAIL":
      return {
        ...state,
        tiPropertyStats: {
          ...state.tiPropertyStats,
          loading: false,
          error,
        },
      };
    case "GET_LATEST_DATA_FILE":
      return {
        ...state,
        type,
        error: null,
        latestFile: {
          ...initialState.latestFile,
          loading: true,
        },
      };

    case "GET_LATEST_DATA_FILE_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        latestFile: {
          ...state.latestFile,
          loading: false,
          data: data,
        },
      };

    case "GET_LATEST_DATA_FILE_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        latestFile: {
          ...state.latestFile,
          loading: false,
          error,
        },
      };
    case "GET_DC_RATE_HISTORY":
      return {
        ...state,
        type,
        error: null,
        dcRateHistory: {
          ...initialState.dcRateHistory,
          loading: true,
        },
      };

    case "GET_DC_RATE_HISTORY_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        prioritizeSuccess: false,
        dcRateHistory: {
          ...state.dcRateHistory,
          loading: false,
          data: data,
        },
      };

    case "GET_DC_RATE_HISTORY_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        dcRateHistory: {
          ...state.dcRateHistory,
          loading: false,
          error,
        },
      };

    //tiPropertyStats
    default:
      return state;
  }
};

export default propertyReducer;
